import { importAllWellsDataFromGeoDBApi } from '@core/core/api'
import type { KsuWell } from '@core/core/types'
import { defaultUploadedFileStepStatuses } from '@core/core/types'
import type { ProjectId } from 'common/types'

import { updateGeoDbFoundEntities } from '../../overallSearch'
import type { AppDispatch } from '../../store'
import { addMultipartFiles } from './common'

export const addRemoteGeoDbWells =
  (projectId: ProjectId, files: KsuWell[]) => async (dispatch: AppDispatch) => {
    for (const file of files) {
      const taskId = await importAllWellsDataFromGeoDBApi(
        projectId,
        files.map(file => file.wellUid),
      )

      dispatch(
        addMultipartFiles([
          {
            projectId,
            fileId: file.ksuUid,
            name: file.wellName,
            uploadId: file.wellUid,
            progress: 0,
            fileSize: 0,
            fileChunk: 0,
            step: 'loading',
            statuses: {
              ...defaultUploadedFileStepStatuses,
              loading: 'inprogress',
              ready: 'notstarted',
            },
            setupContent: undefined,
            initialSetupContent: undefined,
            date: Date.now(),
            origin: 'geodb',
            convertTaskId: taskId,
            entityType: 'well',
          },
        ]),
      )

      dispatch(updateGeoDbFoundEntities([file.wellUid], 'loading'))
    }
  }
